import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hfgiehqxcopeafwdzupw.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhmZ2llaHF4Y29wZWFmd2R6dXB3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg4OTMxNDMsImV4cCI6MjA5NDQ2OTE0M30.ofiyR8bZAJiTjAEJ3KuJv0NCg0B_ZHhQOtQnm_bRrC0';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);